import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from 'src/app/service/http/http.service';
import { ChangeNeededComponent } from '../change-needed/change-needed.component';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-elcm-report',
  templateUrl: './elcm-report.component.html',
  styleUrls: ['./elcm-report.component.scss'],
})
export class ElcmReportComponent implements OnInit {
  selectedSubTab: any = 'EmployeeApplicationMaster';
  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'offerAndAppoinment';
  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any
  selectedYear: any;
  pmsYears: any = [];
  loggedInUserId: any;
  fromYear: any;
  toYear: any;
  from: any;
  getChangedData: any;
  reportingManager: any;
  confirmationProbationWhomSetup: any;
  dropdownSettings: IDropdownSettings = {};
  loggedInUserEmployeeCode: any;
  constructor(private datePipe: DatePipe,

    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    private encryptionService: EncryptionService,

    public dialogRef: MatDialogRef<ElcmReportComponent>,
  ) {

  }

  ngOnInit() {
    if (this.loggedInUserRole == 'HR Admin') {
      this.selectedTypeTabIndex = 0;
      this.selectedTypeTabName = 'offerAndAppoinment';
    } else if (this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
      this.selectedTypeTabIndex = 1;
      this.selectedTypeTabName = 'Probation';
    }
    this.loggedInUserEmployeeCode = sessionStorage.getItem('empCode');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getChangedData = sessionStorage.getItem('ProbassionChangedData');
    this.reportingManager = this.httpService.reportingManagerForElcm;
    this.confirmationProbationWhomSetup = this.httpService.confirmationProbationWhomSetup;
    this.getpmsyearlist();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
  }

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
  }
  onClickSubTab(subTabName: any) {
    this.selectedSubTab = subTabName;
  }






  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         this.from = 'January-December'
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         this.from = 'April-March'
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }

  //       if (ele?.year == yearValue) {
  //         console.log("dgmfdgl");

  //         this.selectedYear = ele?.year;

  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];

  //         this.getEmployeeList();
  //         this.getEmployee();

  //     this.getEmployeeListOnGoal();
  //     this.getProbationEmployeeList();
  //       }


  //     });
  //   })
  // }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls
      this.getEmployeeList();
      this.getEmployee();

      this.getEmployeeListOnGoal();
      this.getProbationEmployeeList();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;


      let test = selectedYearObj?.year.split('-');

      this.fromYear = test[0];
      this.toYear = test[1];

    }
  }

  employeesDetails: any = []
  employeesProbationDetails: any = []
  checkLineManagerAndHodForReport: any = []
  getEmployeeList() {
    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {
      this.employeesDetails = record.data.map((record: any) => {
        return {
          ...record,
          probationStatus: null,
          probationExtensionByDay: null,
          reasonForExtension: null,
          changesPostConfirmation: null,
          dateOfConfirmation: null
        }
      });
      console.log("this.employeesDetails", this.employeesDetails);
      this.checkLineManagerAndHodForReport = this.employeesDetails.filter((record: any) => record.hodCode == record.reportingManagerCode || record.reportingManagerCode == this.loggedInUserEmpCode)

      this.getprobationPeriods()

    })
  }
  probationPeriodData: any = []
  getprobationPeriods() {
    this.httpService.callGetService(`${this.config.getProbation}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`)
      .subscribe((record: any) => {
        console.log("API Response:", record);
        this.probationPeriodData = record.data;
        this.getProbationList();
      });
  }


  EmployeeSummaryData: any = [];
  currentemployeesProbationDetails: any = []
  getDeptList: any = []
  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;

    })
  }
  hodEmployeeList: any = []
  getProbationEmployeeList() {
    this.httpService.callGetService(`${this.config.getEmployeeUnderHod}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.loggedInUserEmployeeCode}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`)
      .subscribe((response: any) => {
        this.hodEmployeeList = response;
        console.log(this.hodEmployeeList);
        this.getProbationList()
      }
      )
  }
  employeeTeamForHod: any = []
  getEmployeeListOnGoal() {
    const request = {
      // "companyId": this.loggedInUserCompanyID,
      // "from": this.from,
      // "fromYear": this.fromYear,
      // "to": this.from,
      // "toYear": this.toYear,
      // "userId": this.loggedInUserId,
      // "userType": null,
      // "loggedInUserRole": this.loggedInUserRole
      "companyId": this.loggedInUserCompanyID,
      "from": "January-December",
      "fromYear": this.fromYear,
      "to": "January-December",
      "toYear": this.toYear,
      "userId": this.loggedInUserId,
      "userType": null,
      "loggedInUserRole": this.loggedInUserRole
    }
    this.httpService.callPostService(this.config.getTeamOfManagerByDate, request).
      subscribe((data: any) => {
        this.employeeTeamForHod = data?.data;

      })
  }

  probationListData: any = [];
  checkLineManagerAndHodForReportForConfirmation: any;
  getProbationList() {
    this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        if (!response || !response?.data) return;

        this.currentemployeesProbationDetails = response.data

        console.log("this.currentemployeesProbationDetails", this.currentemployeesProbationDetails);

        this.checkLineManagerAndHodForReportForConfirmation = this.currentemployeesProbationDetails.filter((record: any) => record.hodCode == record.reportingManagerCode || record.reportingManagerCode == this.loggedInUserEmpCode)


        if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD')) {
          this.employeesProbationDetails = response?.data;
          this.currentemployeesProbationDetails = this.employeesProbationDetails
          //
        } else if (this.loggedInUserRole == 'Manager' && this.confirmationProbationWhomSetup == 'LINE_MANAGER') {

          const employeeId = this.EmployeeSummaryData.map((record: any) => record.id);
          console.log("manager...............", this.currentemployeesProbationDetails);
          this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => employeeId.includes(record.userId) || this.loggedInUserEmpCode == record.reportingManagerCode);
          this.currentemployeesProbationDetails = this.employeesProbationDetails
        } else if (this.loggedInUserRole == 'HOD' && this.confirmationProbationWhomSetup == 'HOD') {
          const employeeId = this.hodEmployeeList?.data?.data.map((record: any) => record.userId);
          this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => employeeId.includes(record.userId) || this.loggedInUserEmpCode == record.hodCode);
          this.currentemployeesProbationDetails = this.employeesProbationDetails
        } else if (this.loggedInUserRole == 'HOD' && this.confirmationProbationWhomSetup == 'LINE_MANAGER' && (this.checkLineManagerAndHodForReport.length > 0 || this.checkLineManagerAndHodForReportForConfirmation.length > 0)) {
          console.log("hod and manager");

          this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) => (this.loggedInUserEmpCode == record.hodCode && this.loggedInUserEmpCode == record.reportingManagerCode)||(this.loggedInUserEmpCode==record.reportingManagerCode));
          this.currentemployeesProbationDetails = this.employeesProbationDetails
        

        }
        this.getDeptList = []
        this.currentemployeesProbationDetails.forEach((ele: any) => {
          const deptName = ele.empDept.trim().toLowerCase(); // Normalize the department name

          // Check if the department already exists in the list
          if (!this.getDeptList.some((record: any) => record.empDept.trim().toLowerCase() === deptName)) {
            this.getDeptList.push({
              id: deptName,
              empDept: deptName, // Assuming 'empDept' is the property to store department names
              name: deptName,
            });
          }
        });

        console.log(this.employeesProbationDetails);

      });
  }


  OfferAndAppointmentTableHeader: any = [
    { label: "Sr.No" },
    { label: "Emp ID" },
    { label: "Emp name" },
    { label: "Dept" },
    { label: "Band" },
    { label: "Grade" },
    { label: "Date of Joining" },
    { label: "Date of Confirmation" },
    { label: "Probation" },
    { label: "Extention of probation by" },
    { label: "Reasons for confirmation orprobation extension" },
    { label: "Change post confirmation" },

  ]





  onClickOpenChangeNeededPopup(userId: any, tabName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      userID: userId,
      tabName: tabName
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ChangeNeededComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result: any) => {


    });
  }

  getProbationEmployeeDetails: any;
  getprobationData(employee: any) {
    console.log(employee);
    this.getProbationEmployeeDetails = employee
    console.log(this.probationPeriodData);

  }


  onProbationChange(event: any) {
    let probationDay = this.probationPeriodData.find((elm: any) => elm.grade == event.grade && elm.band == event.band);
    console.log(this.getProbationEmployeeDetails.probationStatus);


    if (this.getProbationEmployeeDetails.probationStatus == 'Extension') {
      event.probationExtensionByDay = probationDay.probationPeriod;
    } else if (this.getProbationEmployeeDetails.probationStatus == 'Confirmation') {
      event.probationExtensionByDay = null;
    }
  }

  employees: any = []
  searchTerm: any = ''; // Holds search input value
  filteredEmployees: any[] = []; // Holds filtered employee list

  filterEmployees() {
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      return this.employees; // Return full list if no search term
    }
    const searchTextLower = this.searchTerm.toLowerCase().trim();

    let data = this.currentemployeesProbationDetails.filter((employee: any) =>
      Object.values(employee).some(value => {
        if (value === null || value === undefined) return false; // Skip null/undefined
        return value.toString().toLowerCase().includes(searchTextLower);
      })
    );

    this.employeesProbationDetails = data;


  }

  DislaySelectedRecord(event: any) {
    this.employeesProbationDetails = this.currentemployeesProbationDetails.slice(0, event.value);
  }


  downloadCSV() {
    const header = ["sr No", "Emp ID", "Emp name", "Dept", "Band", "Grade", "DOJ", "Date off Confirmation", "Probation", "Extention of probation by", "Reasons for confirmation or probation extension", "Change post confirmation"]
    //  if(this.loggedInUserRole === 'HR Admin'){
    //    header.push("Change post confirmation");
    //  }
    const headers = header.map((h: any) => h);
    const rows = this.employeesProbationDetails.map((employee: any, index: any) => [
      index + 1,
      employee.emplCode,
      employee.empName,
      employee.empDept,
      employee.band,
      employee.grade,
      this.datePipe.transform(employee.doj, 'dd-MM-yyyy') || '',  // Format DOJ
      this.datePipe.transform(employee.dateOfConfirmation, 'dd-MM-yyyy') || '',  // Format Date of Confirmation
      employee.probationStatus,
      employee.probationExtensionByDay,
      employee.reasonForExtension,
      employee.changesPostConfirmation
    ]);


    let csvContent = "data:text/csv;charset=utf-8,"
      + [headers, ...rows].map(e => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Probation_Details.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  fiterDataForDep() {

    if (this.selectedDep.length > 0) {
      console.log(this.selectedDep);

      // Normalize the deptID array by trimming and converting to lowercase
      const deptID = this.selectedDep.map((elm: any) => elm.id.trim().toLowerCase());

      // Filter employees based on the normalized deptID values
      this.employeesProbationDetails = this.currentemployeesProbationDetails.filter((record: any) =>
        deptID.includes(record.empDept.trim().toLowerCase()) // Normalize empDept as well
      );
    }

    else {
      this.clearSelections();

      this.employeesProbationDetails = this.currentemployeesProbationDetails;
    }


  }
  clearSelections() {
    this.selectedDep = [];
  }
  selectedDep: any = [];
  onSelectDepartment() {

    if (this.selectedDep && this.selectedDep.length > 0) {
      this.fiterDataForDep();
    } else {
      this.clearSelections(); // Clear selections if no department is selected
    }
  }

  onDeSelectDepartment() {
    // this.selectedDep = [];
    this.fiterDataForDep();
  }

  selectAllDepartment(items: any): void {
    this.selectedDep = items; // Select all departments
    this.fiterDataForDep();

  }


  onDeSelectAllDepartment() {
    this.selectedDep = [];
    // this.selectedEmployee = [];
    // this.getEmployeeList = [];
    // this.assetAllocationData()

  }
  shouldShowProbationReport(): boolean {
    return this.selectedTypeTabName === 'Probation' ||
      (this.loggedInUserRole === 'HOD' && this.confirmationProbationWhomSetup === 'HOD') ||
      (this.loggedInUserRole === 'Manager' && this.confirmationProbationWhomSetup === 'LINE_MANAGER') || (this.checkLineManagerAndHodForReport.length > 0 || this.checkLineManagerAndHodForReportForConfirmation.length > 0) && this.confirmationProbationWhomSetup === 'LINE_MANAGER' && this.loggedInUserRole === 'HOD'

  }


}

